<template>
    <div>
        <b-card no-body>
            <div class="row">
                <input-select-filter label="Empresa" :options="empresas" class="col-12" v-model="form.empresaId" ref="empresa" required/>
                <input-date-time label="Data da assinatura" class="col-12 col-md-6" v-model="form.dataAssinatura" ref="dataAssinatura" required />
                <input-date-time label="Data do encerramento" class="col-12 col-md-6" v-model="form.dataEncerramento" />
                <div class="col-12">
                    <upload v-if="!form.nomeAnexoAWS"
                        type=".pdf"
                        :arquivo-download-nome="form.nomeAnexoAWSUP"
                        :arquivo-download="form.anexoBase64"
                        @upload="(file, nomeArquivo)=> {                   
                            form.nomeAnexoAWSUP = nomeArquivo;
                            form.anexoBase64 = file;
                        }"
                        selecioneArquivo="Selecione o contrato de licença"
                        tituloArquivo="Arraste o contrato de licença"
                    />

                    <template v-if="form.nomeAnexoAWS">
                        <div>
                            Contrato de Licença
                            <div class="lista-arquivos d-flex">
                                <b-button variant="danger" @click="removerAnexoContrato" class="m-2" size="sm">
                                    <b-icon icon="trash" class="mr-2" />
                                    Remover arquivo
                                </b-button>
                                <b-button variant="info" @click="downloadAnexoContrato(form.id)" class="m-2" size="sm">
                                    <i class="fas fa-cloud-download"></i>
                                </b-button>
                                <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                                    {{form.nomeAnexoAWS}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-12 mt-3">
                    <b-button variant="success" @click="salvar">
                        <i class="fa fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </div>
            </div>
        </b-card>

        <accordion
            class="mt-3"
            title="Parcelas"
            id="parcelas"
            v-if="form.id"
        >
            <template #append-title>
                <b-button class="ml-2" @click="novaParcela" size="sm">
                    <i class="fas fa-plus mr-2"></i>
                    Adicionar parcela
                </b-button>
            </template>
            <div class="p-3">
                <form-modal 
                    id="parcelas"
                    hide-button
                    title-modal="Parcela"
                    :fields="colunas"
                    :values="form.parcelas"
                    ref="modalParcelas"
                    create
                    update
                    read
                    remove
                    controles
                    @ok="salvarParcela"
                    @edit="editarParcela"
                    @cancel="inicializarFormParcela"
                    @remove="removerParcela"
                >
                    <template #modal>
                        <modal :form="formParcela" ref="form-parcela"  />
                    </template>
                </form-modal>
            </div>
        </accordion>



    </div>
</template>
<script>
import ContratoLicencaService from '@/common/services/contrato_licenca/contrato_licenca.service'
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import InputDateTime from '@/components/inputs/InputDateTime.vue';
import InputSelectFilter from '../../components/inputs/InputSelectFilter.vue';
import Upload from '@/components/upload/Upload.vue';
import { FormMixin } from '../../common/mixins/FormMixin';
import { AlertasMixin } from '../../common/mixins/AlertasMixin';
import EmpresasService from "@/common/services/empresas/empresas.service";
import Accordion from '../../components/card/Accordion.vue';
import helpers from '../../common/utils/helpers';
import FormModal from '../../components/modal/FormModal.vue';
import Modal from "./ContratoModal.vue"
import cloneDeep from 'lodash/cloneDeep';

export default {
    mixins: [FormMixin, AlertasMixin],
    components: {
        InputDateTime,
        Upload,
        InputSelectFilter,
        Accordion,
        FormModal,
        Modal
    },
    props : ["id"],
    data : () => ({
        form : {
            dataAssinatura : null,
            dataEncerramento : null,
            anexoBase64 : null,
            nomeArquivo : null,
            parcelas : [],
        },
        formParcela : {
            previsaoEmissao : null,
            emissao : null,
            cobrancaBase64 : null,
            comprovanteBase64 : null,
        },
        empresas : [],
        colunas : [
            {key: "previsaoEmissao", label: "Data de previsão de emissão",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            {key: "emissao", label: "Data de emissão",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            {key: "actions", label: "Ações",},
        ],
    }),
    methods : {
        salvar : function(){
            if(!this.validarFormulario())
                return;

            if(this.form.anexoBase64 == null && this.form.nomeAnexoAWS == null){
                this.alertaErro('Anexo obrigatório');
                return;
            }

            if(this.form.nomeAnexoAWSUP){
                this.form.nomeAnexoAWS = this.form.nomeAnexoAWSUP;
                delete this.form['nomeAnexoAWSUP'];
            }

            this.confirmar('Deseja realmente salvar o contrato de licença?').then(confirmado => {
                if(!confirmado)
                    return;
                this.$store.dispatch(START_LOADING);
                ContratoLicencaService.contratoLicenca(this.form).then(() => {
                    this.alertaSucesso('Contrato de licença salvo com sucesso').then(() => {
                        this.$router.push({name: 'contrato-licenca'});
                    });
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else   
                        this.alertaErro("Erro ao salvar");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        salvarParcela : function(){
            if(!this.$refs['form-parcela'].validarFormulario())
                return;

            this.confirmar('Deseja realmente salvar a parcela?').then(confirmado => {
                if(!confirmado)
                    return;
                this.$store.dispatch(START_LOADING);
                this.formParcela.contratoLicencaId = this.id;

                if(this.formParcela.nomeCobrancaAWSUP){
                    this.formParcela.nomeCobrancaAWS = this.formParcela.nomeCobrancaAWSUP;
                    delete this.formParcela['nomeCobrancaAWSUP'];
                }
                if(this.formParcela.nomeComprovanteAWSUP){
                    this.formParcela.nomeComprovanteAWS = this.formParcela.nomeComprovanteAWSUP;
                    delete this.formParcela['nomeComprovanteAWSUP'];
                }

                ContratoLicencaService.parcela(this.formParcela).then(() => {
                    this.alertaSucesso('Parcela salva com sucesso').then(() => {
                        this.inicializarFormParcela();
                        this.$refs.modalParcelas.closeModal();
                    })
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else   
                        this.alertaErro("Erro ao salvar");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        editarParcela : function(parcela){
            this.formParcela = cloneDeep(parcela);
            this.$refs.modalParcelas.openModal();
        },
        removerParcela : function(parcela){
            this.confirmar('Deseja realmente remover a parcela?').then(confirmado => {
                if(!confirmado)
                    return;
                this.$store.dispatch(START_LOADING);
                ContratoLicencaService.removerParcela(parcela.id).then(() => {
                    this.alertaSucesso('Parcela removida com sucesso').then(() => {
                        this.inicializarFormParcela();
                        this.$refs.modalParcelas.closeModal();
                    })
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else   
                        this.alertaErro("Erro ao remover");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        removerAnexoContrato: function(){
            this.form.nomeAnexoAWS = null;
        },
        buscarEmpresas : function(){
            EmpresasService.listar().then((result) => {
                result.data.data.itens.sort((a, b) => a.nomeFantasia.localeCompare(b.nome));
                this.empresas = result.data.data.itens.map(el => {
                    return {
                        text : el.nomeFantasia,
                        value : el.id
                    }
                });
            });
        },
        buscar : function(){
            this.$store.dispatch(START_LOADING);
            ContratoLicencaService.buscarContrato(this.id).then(response => {
                this.form = response.data.data;
                this.form.dataAssinatura = helpers.formatarDataBr(this.form.dataAssinatura);
                this.form.dataEncerramento = helpers.formatarDataBr(this.form.dataEncerramento);
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        inicializarFormParcela : function(){
            this.formParcela = {
                previsaoEmissao : null,
                emissao : null,
                cobrancaBase64 : null,
                comprovanteBase64 : null,
                nomeCobrancaAWS: null,
                nomeComprovanteAWS: null,
            };
            this.buscar();
        },
        downloadAnexoContrato: function (itemId) {
            this.$store.dispatch(START_LOADING);

            ContratoLicencaService.downloadContrato(itemId)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            })
            .catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            })
            .finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        novaParcela : function(e){
            e.stopPropagation();
            this.$refs.modalParcelas.openModal();
        },
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Contratos de licença", to : {name : "contrato-licenca"} }, { titulo: !this.id ? "Cadastrar" : "Editar",}]);
        if(this.id)
            this.inicializarFormParcela();
        this.buscarEmpresas();
    },
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>